import { Shell } from './components';
import { resolvePage } from './navigation';
import { HomePage } from './pages/HomePage';
import { InvitePage } from './pages/InvitePage';
import { LegalPage } from './pages/LegalPage';
import { MockupsPage } from './pages/MockupsPage';
import { PrintPage } from './pages/PrintPage';
import { SupportPage } from './pages/SupportPage';

export function App() {
  const page = resolvePage(window.location.pathname);
  if (page === 'home') return <HomePage />;
  if (page === 'invite') return <InvitePage />;
  if (page === 'print') return <PrintPage />;
  if (page === 'mockups') return <MockupsPage />;
  if (page === 'privacy') return <LegalPage kind="privacy" />;
  if (page === 'terms') return <LegalPage kind="terms" />;
  if (page === 'support') return <SupportPage />;
  return (
    <Shell>
      <main className="not-found">
        <p className="eyebrow">404</p>
        <h1>ページが見つかりません</h1>
        <p>URLをご確認いただくか、ホームへお戻りください。</p>
        <a className="button primary" href="/">
          ホームへ戻る
        </a>
      </main>
    </Shell>
  );
}
